



































import Vue from "vue"
import { countryList } from "@/model/service/country/country-service"
import moment, { Moment } from "moment"
import { PostalCode } from "@/model/entity/postal-code/postal-code"

export default Vue.extend({
  components: {},
  data() {
    return {
      postalCode: new PostalCode(),
      countryList: countryList,
      rules: {
        postalCode: [
          {
            max: 9,
            message: `${this.$t("user_administration.max")} 9 ${this.$t("user_administration.chars")}`,
            trigger: ["change", "blur"]
          },
          {
            required: true,
            message: `${this.$t("user_administration.field_is_required")}`
          }
        ],
        country: [
          {
            required: true,
            message: `${this.$t("user_administration.field_is_required")}`
          }
        ]
      }
    }
  },
  methods: {
    emitValidation() {
      const vm = this as any
      let isInfoFormValid
      vm.$refs.formInfo.validate(valid => {
        isInfoFormValid = valid
      })
      this.$emit("validateForm", isInfoFormValid)
    }
  },
  watch: {
    "postalCode" : {
        deep: true,
        handler() {
            this.emitValidation()
            this.$emit("modelChanged", this.postalCode)
        }
    }
  },
  mounted() {
    this.emitValidation()
  }
})
